export default "__VITE_ASSET__48f25560__"